import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faCheckCircle,
  faCalendarAlt,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Router } from "@angular/router";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
//import { totalmem } from "os";

@Component({
  selector: "app-adminCorderosForm",
  templateUrl: "./adminCorderosForm.component.html",
  styleUrls: ["./adminCorderosForm.component.css"],
})
export class AdminCorderosFormComponent implements OnInit {
  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoVal = faCheckCircle;
  icoFec = faCalendarAlt;
  icoFac = faFileAlt;
  usuarioActual: any;

  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  modoLis = 0;
  formLis = 0;
  SwDetal = false;
  SwTotal = false;
  SwExcel = false;
  SwImpre = false;
  SwLista = false;
  SwGrafi = false;
  resul: boolean;

  prifec: string;
  ultfec: string;

  faArrowRight = faArrowRight;
  faArrowLeft = faArrowLeft;

  fincas: any[] = [];

  icoFecha: any;

  pasoActual = 1;
  resultado = false;

  entregaData = {
    codigo: "",
    ganadero: "",
    finca: "",
    recoger: 0,
    machos: 0,
    hembras: 0,
    total: 0,
    observaciones: "",
  };

  clientes: any[] = [];
  clienteSeleccionado: any = 0;

  constructor(
    private srvCentral: CentralService,
    private router: Router,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    const now = new Date();
    this.fecdia = now.toLocaleString("es-ES");
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }

    this.usuarioActual = localStorage.getItem("usuarioActual");
    this.entregaData.codigo = JSON.parse(this.usuarioActual || "{}").codUsu;

    this.srvCentral.consulFinca(this.entregaData.codigo).subscribe((datos) => {
      this.fincas = datos;
    });
    this.modoLis = this.srvCentral.PnsModoLis;
    this.formLis = this.srvCentral.PnsFormLis;
    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);

    this.srvCentral.listClientes().subscribe({
      next: (res) => {
        if (!res || res.length === 0) {
          this.clientes = [
            { ttSocio: 0, ttNombr: "No hay clientes", ttEsSocio: "" },
          ];
        } else {
          this.clientes = [
            { ttSocio: 0, ttNombr: "Todos", ttEsSocio: "" },
            ...res,
          ];
        }
      },
      error: (err) => {
        console.error("Error al cargar clientes:", err);
        this.clientes = [
          { ttSocio: 0, ttNombr: "Error en la consulta", ttEsSocio: "" },
        ];
      },
    });

    switch (this.modoLis) {
      case 0:
        this.SwDetal = true;
        break;
      case 1:
        this.SwTotal = true;
        break;
    }

    switch (this.formLis) {
      case 0:
        this.SwLista = true;
        break;
      case 1:
        this.SwImpre = true;
        break;
      case 2:
        this.SwExcel = true;
        break;
      case 3:
        this.SwGrafi = true;
        break;
    }

    this.entregaData.ganadero = this.nomusu;
  }
  persiana(): void {
    $("#wrapper").toggleClass("toggled");
  }

  cantidadesValidas(): boolean {
    return this.entregaData.machos >= 0 && this.entregaData.hembras >= 0;
  }

  fincaValida(): boolean {
    return this.entregaData.finca.trim() !== "";
  }

  actualizarTotal(): void {
    this.entregaData.total =
      (this.entregaData.machos || 0) + (this.entregaData.hembras || 0);
  }

  siguientePaso() {
    if (this.pasoActual < 3) {
      this.pasoActual++;
    }
  }

  anteriorPaso() {
    if (this.pasoActual > 1) {
      this.pasoActual--;
    }
  }

  enviarEntrega() {
    this.resul = true;

    this.entregaData.total =
      (this.entregaData.machos || 0) + (this.entregaData.hembras || 0);

    const hoy = new Date();
    const dd = String(hoy.getDate()).padStart(2, "0");
    const mm = String(hoy.getMonth() + 1).padStart(2, "0");
    const yyyy = hoy.getFullYear();
    const fechaStr = `${dd}/${mm}/${yyyy}`;

    const linea = {
      ttClave: 0,
      ttSocio: Number(this.entregaData.codigo),
      ttNombr: "",
      ttFecha: fechaStr,
      ttOrden: 0,
      ttExplo: this.entregaData.finca,
      ttHembra: Number(this.entregaData.hembras),
      ttMachos: Number(this.entregaData.machos),
      ttTotcor: Number(this.entregaData.total),
      ttRecoge: Number(this.entregaData.recoger),
    };

    //console.log("Objeto a enviar:", linea);

    this.srvCentral.entregacord(0, [linea]).subscribe({
      next: (resp) => {
        //console.log("Respuesta backend:", resp);
        alert("Entrega registrada correctamente");
        this.reiniciarFormulario();
        this.resul = false;
      },
      error: (err) => {
        console.error("Error enviando entrega:", err);
        alert("Error al registrar la entrega");
        this.resul = false;
      },
    });
    this.router.navigate(["/adminPanel"]);
  }

  reiniciarFormulario() {
    this.pasoActual = 1;
    this.entregaData = {
      codigo: "",
      ganadero: "",
      finca: "",
      recoger: 0,
      machos: 0,
      hembras: 0,
      total: 0,
      observaciones: "",
    };
  }

  clienteSeleccionadoCambio(): void {
    const cliente = this.clientes.find(
      (c) => c.ttSocio == this.clienteSeleccionado
    );

    if (cliente) {
      this.entregaData.ganadero = cliente.ttNombr;
      this.entregaData.codigo = cliente.ttSocio;
    } else {
      this.entregaData.ganadero = "";
    }

    this.srvCentral.consulFinca(this.clienteSeleccionado).subscribe({
      next: (datos) => {
        this.fincas = datos;
        if (this.fincas.length === 0) {
          alert("Este cliente no tiene fincas asignadas.");
        }
      },
      error: (err) => {
        console.error("Error al cargar fincas del cliente:", err);
        alert("Error cargando fincas del cliente");
        this.fincas = [];
      },
    });

    this.entregaData.finca = "";
  }
}
